<div class="chart-wrapper" *ngIf="showDoughnutChart && data?.length">
    <canvas baseChart [data]="doughnutChartData" [labels]="doughnutChartLabels" [chartType]="doughnutChartType">
    </canvas>
</div>

<h5 *ngIf="!showDoughnutChart || !data?.length">Il n'y a pas de données pour {{ getMonthOrYear()}}</h5>